import axios from '@/libs/api.request'
// 获取耗材列表
export const getExpendablesList = (params) => {
    return axios.request({
        url: 'consumables_selection',
        method: 'get',
        params: params
    })
}

export const checkSelection = (params) => {
    return axios.request({
        url: 'consumables_selection_spec/check',
        method: 'get',
        params: params
    })
}
